// extracted by mini-css-extract-plugin
export default {"pt_1":"Company_pt_1__KFSHW","ml_2":"Company_ml_2__Ez-O-","btn_space":"Company_btn_space__qXfo2","accordionMui":"Company_accordionMui__m8K7n"};